
export class Centro {
  id: number;
  descricao: string;
}



// WEBPACK FOOTER //
// ./src/app/centros/centro.ts